import { ChevronRightIcon } from '@heroicons/react/20/solid';

import AccountPopover from '@/components/app-shell/AccountPopover';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Avatar } from '@/components/ui/custom/dataDisplay/Avatar';
import { useAppShell } from '@/data/context/AppShellContext';
import { handleUserFullName } from '@/functions/handleUserFullName';

type ShellUserCardProps = {
  isOpen: boolean;
  onNavigate(): void;
};

export default function ShellUserCard({
  isOpen,
  onNavigate,
}: ShellUserCardProps) {
  const { user } = useAppShell();

  return (
    <AccountPopover
      onNavigate={onNavigate}
      className={isOpen ? 'w-full rounded-2xl bg-base-300 p-2' : 'rounded-full'}
    >
      <Avatar userId={user.id} size="12" className="ring-2 ring-base-100" />
      <ConditionalRenderer condition={isOpen}>
        <span className="min-w-0 flex-1 truncate text-left text-xs font-semibold text-base-content">
          {handleUserFullName(user)}
        </span>
        <ChevronRightIcon className="size-5 shrink-0 text-base-content" />
      </ConditionalRenderer>
    </AccountPopover>
  );
}
